import { SelectProps } from 'antd/lib'
import { useTranslation } from 'react-i18next'

import { InternationalNameUsability } from 'src/api/requests'

export const useUsabilityOptions = () => {
  const { t } = useTranslation()

  const options: SelectProps['options'] = [
    {
      value: InternationalNameUsability.ALL,
      label: t('medicine_register.international_name.all')
    },
    {
      value: InternationalNameUsability.ONLY_USED,
      label: t('medicine_register.international_name.only_used')
    },
    {
      value: InternationalNameUsability.NOT_USED,
      label: t('medicine_register.international_name.only_not_used')
    }
  ]

  return { options }
}
